const policies = {
	name: "Policies",
	query: `
  query templatePolicies($limit:Int $sort:sortInput $where:policyWhereInput){
    policies(limit:$limit sort:$sort where:$where) {
      list{
        id
        issueDate
        issuerNumber
       	startDate
        endDate
        cancellationReason
        contractHolder {
          ...on individual {
          addresses { 
          	fields
            fields2 { value }
            type
          }
          contacts {
            type value
          }
          chineseFirstName
          chineseLastName
          dateOfBirth
          email
          facts { type value { booleanValue dateValue stringValue numberValue }}
          identities { type value }
          name
          telephoneNumber
          salutation
          relationships { type }
         }
         ...on company {
          addresses { 
            fields
            fields2 { value }
            type
            }
           contacts { type value }
           facts { type value { booleanValue dateValue stringValue numberValue }}
           identities { type value }
           name
           natureOfBusiness
           registrationNumber
           relationships { type entity { name } }
         }
        }
        contractInsured {
          ...on individual {
            addresses { 
          	fields
            fields2 { value }
            type
          }
          contacts {
            type value
          }
          chineseFirstName
          chineseLastName
          dateOfBirth
          email
          facts { type value { booleanValue dateValue stringValue numberValue }}
          identities { type value }
          name
          telephoneNumber
          salutation
          relationships { type }
          }
          ...on company {
            addresses { 
              fields
              fields2 { value }
              type
              }
             contacts { type value }
             facts { type value { booleanValue dateValue stringValue numberValue }}
             identities { type value }
             name
             natureOfBusiness
             registrationNumber
             relationships { type entity { name } }
          }
          ...on object {
            addresses { 
              fields
              fields2 { value }
              type
              }
            contacts { type value }
            facts { type value { booleanValue dateValue stringValue numberValue }}
            identities { type value }
            name
            relationships { type entity { name }  }
          }
        }
        otherContractHolders {
          ...on individual {
            addresses { 
          	fields
            fields2 { value }
            type
          }
          contacts {
            type value
          }
          chineseFirstName
          chineseLastName
          dateOfBirth
          email
          facts { type value { booleanValue dateValue stringValue numberValue }}
          identities { type value }
          name
          telephoneNumber
          salutation
          relationships { type }
          }
        }
        facts {
          id
          type
          value {
            stringValue
            numberValue
            dateValue
          }
        }
        premium {
          amount
          appliedDiscounts { flat ratio }
          appliedTaxes { code flat ratio }
          currencyCode
          formattedOriginalPrice
          formattedPrice
          loadings { flat ratio }
          originalPrice
          paymentFrequency
        }
        product {
          name
          productId { plan }
          pricing { currencyCode }
          type { name }
        }
        referrer { internalCode name }
        rejectionCodes { code name }
        exclusions { id codeName {code name}}
      }
    }
  }`
}

export default policies
